import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex min-w-0 w-full relative" }
const _hoisted_2 = {
  key: 0,
  class: "w-14 flex-shrink-0"
}
const _hoisted_3 = { class: "flex-1 flex items-center gap-2 min-w-0 px-3" }
const _hoisted_4 = { class: "flex-1 flex h-[60px] min-w-0" }
const _hoisted_5 = { class: "flex-1 flex flex-col gap-1.5 min-w-0 h-full" }
const _hoisted_6 = { class: "flex-shrink-0 text-xs leading-tight text-primary opacity-80 truncate" }
const _hoisted_7 = {
  key: 0,
  class: "flex-shrink-0 flex items-end h-10 overflow-hidden"
}
const _hoisted_8 = { class: "text-primary leading-5 font-bold" }
const _hoisted_9 = {
  key: 1,
  class: "flex-shrink-0 text-primary leading-5 font-bold truncate"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "flex-shrink-0 flex items-center gap-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", { class: "icon w-5 h-5 transition delay-75 stroke-[4.5]" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#more" })
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  class: "w-9 h-9 absolute z-10 -rotate-90",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#play" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "assets/icons.svg#pause" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NetworkImageComponent = _resolveComponent("NetworkImageComponent")!
  const _component_TranscriptionsComponent = _resolveComponent("TranscriptionsComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.getPostImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_NetworkImageComponent, {
            class: "w-full h-full object-cover",
            image: _ctx.getPostImage,
            width: 60,
            height: 90,
            alt: _ctx.post.profile.url
          }, null, 8, ["image", "alt"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.contributorName), 1),
          (_ctx.showTranscriptionsComponent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.post && _ctx.post.transcript)
                    ? (_openBlock(), _createBlock(_component_TranscriptionsComponent, {
                        key: 0,
                        "current-time": _ctx.originalCurrentTime,
                        transcript: _ctx.post.transcript
                      }, null, 8, ["current-time", "transcript"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showRawTranscriptions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.truncatedRawTranscription), 1))
            : _createCommentVNode("", true),
          (_ctx.showRawTranscriptions)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: _ctx.portalShareURL,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackClickOut('mainLogo'))),
                rel: "nofollow noopener",
                target: "_blank",
                class: "flex-shrink-0 mt-auto text-primary/60 transition hover:text-primary text-[10px] leading-3 truncate"
              }, "Powered by Beams.fm", 8, _hoisted_10))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showShareOverlay && _ctx.showShareOverlay(...args))),
          class: "flex justify-center items-center h-6 w-6 text-primary/60 transition hover:text-primary"
        }, _hoisted_13),
        _createElementVNode("button", {
          class: "w-10 h-10 relative inline-flex items-center justify-center bg-primary text-background rounded-full overflow-hidden flex-shrink-0 transition will-change-transform hover:scale-95",
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePlayPause && _ctx.togglePlayPause(...args)), ["prevent","stop"])),
          "aria-label": "Play / Pause"
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_14, [
            _createElementVNode("circle", {
              cx: "18",
              cy: "18",
              r: "16.5",
              class: "progress-circle",
              style: _normalizeStyle(`--percent: ${_ctx.progress}`)
            }, null, 4)
          ])),
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["icon absolute w-5 h-5 transition delay-75 z-20", { 'opacity-100': !_ctx.isPlaying, 'opacity-0': _ctx.isPlaying }])
          }, _hoisted_16, 2)),
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass(["icon absolute w-5 h-5 transition delay-75 z-20", { 'opacity-100': _ctx.isPlaying, 'opacity-0': !_ctx.isPlaying }])
          }, _hoisted_18, 2))
        ])
      ])
    ])
  ]))
}